import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const StaggeredSectionImageStyleLarge: MediaSetting[] = [
  {
    screen: Screen.XXXS,
    key: '2_1_540',
    width: 540,
    height: 270,
    ratio: 2,
  },
  {
    screen: Screen.XXS,
    key: '2_1_568',
    width: 568,
    height: 284,
    ratio: 2,
  },
  {
    screen: Screen.XS,
    key: '2_1_768',
    width: 768,
    height: 384,
    ratio: 2,
  },
  {
    screen: Screen.SM,
    key: '3_2_492',
    width: 500,
    height: 334,
    ratio: 1.5,
  },
  {
    screen: Screen.MD,
    key: '3_2_414',
    width: 500,
    height: 333,
    ratio: 1.5,
  },
  {
    screen: Screen.XL,
    key: '3_2_492',
    width: 500,
    height: 334,
    ratio: 1.5,
  },
];

export const StaggeredSectionImageStyleSmall: MediaSetting[] = [
  {
    screen: Screen.XXXS,
    key: '2_1_540',
    width: 400,
    height: 200,
    ratio: 2,
  },
  {
    screen: Screen.XXS,
    key: '2_1_568',
    width: 568,
    height: 284,
    ratio: 2,
  },
  {
    screen: Screen.XS,
    key: '3_2_300',
    width: 300,
    height: 200,
    ratio: 1.5,
  },
];
